<template>
  <div class="chat-header" :class="{ minimized: isMinimized }">
    <template v-if="!isMinimized">
      <div class="moving-handler"></div>
      <div class="solomon-info">
        <div class="solomon-profile" @mousedown.stop>
          <i class="icon icon--becle-profile"></i>
          <div :class="['status', { disabled: !isConnected }]"></div>
        </div>
        <div class="solomon-detail">
          <div class="solomon-name">Beusable Docent</div>
          <i class="icon icon--beta"></i>
        </div>
      </div>
    </template>
    <div class="button-container">
      <button
        v-if="!isMinimized"
        class="minimize-button"
        @click="$emit('minimize')"
      >
        <i class="icon icon--size-minimize"></i>
      </button>
      <button v-else class="restore-button" @click="$emit('restore')">
        <i class="icon icon--size-restore"></i>
      </button>
      <button
        v-if="(isResized || isMoved) && !isMinimized"
        class="initialize-button"
        @click="$emit('initialize')"
      >
        <i class="icon icon--size-initialize"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatHeader",
  props: {
    isConnected: Boolean,
    isResized: Boolean,
    isMoved: Boolean,
    isMinimized: Boolean
  }
};
</script>

<style lang="scss" scoped>
.chat-header {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 8px;
  .solomon-info {
    display: flex;
    align-items: center;
    gap: 16px;
    .solomon-profile {
      position: relative;
      width: 42px;
      height: 42px;
      cursor: default;
      .solomon-profile-img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        box-shadow: 0px 0px 0px 0.36px #22637829 inset;
      }
      .status {
        position: absolute;
        right: 1px;
        bottom: 2px;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        border: 2px solid #fff;
        background-color: #58c900;
        box-sizing: border-box;
        box-shadow: 0px 1px 2px 0px #00000040;
        &.disabled {
          background-color: #e92020;
        }
      }
    }

    .solomon-detail {
      display: flex;
      flex-direction: row;
      gap: 6px;
      .solomon-name {
        position: relative;
        width: fit-content;
        color: #111;
        font-size: 13px;
        font-weight: 600;
        line-height: 120%;
      }
      .gpt-version {
        color: #7d7d7d;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }

  .moving-handler {
    display: none;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 52px;
    height: 4px;
    border-radius: 2px;
    background-color: #888;
  }

  .button-container {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin: -4px -4px 0 0;
    button {
      display: flex;
      padding: 4px;
      border-radius: 8px;
      &:hover {
        background-color: rgba(0, 0, 0, 0.06);
      }
    }
  }

  &.minimized {
    padding-top: 0;
    .button-container {
      margin: 0;
      button {
        padding: 16px;
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
  &:hover {
    .moving-handler {
      display: block;
    }
  }

  &:has(.solomon-profile:hover),
  &:has(button:hover) {
    .moving-handler {
      display: none;
    }
  }
}
</style>
